import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';

import {ErrorWarningsCategory} from '../../utils/enums.js';
import LANGUAGES_CONTROLLER from '../../controllers/languages';
import { SSelect } from "@avalara/skylab-sdk/react";
import Logger, {LOG_LEVELS} from '../../utils/logger';

const log = new Logger('ERRORS_CATEGORY_SELECTOR', LOG_LEVELS.DEBUG);

export class ErrorsCategorySelector extends React.Component {

  selectionHandler(event) {
    log.debug('selectionHandler(): ', event);
    log.debug('selectionHandler(): target.value', event.detail.item.value);
    this.props.selectionHandler({errorCategory: event.detail.item.value === '' ? undefined : event.detail.item.value})
  }

  getFilterByCategoryOptions() {
    let optionsList = [];
    this.props.categoryList.forEach((errorCategory, key) => {
      let langStr = LANGUAGES_CONTROLLER.format(this.props.languages, errorCategory.languageString);
      optionsList.push({
        label: langStr,
        value: langStr,
        selected: this.props.value === langStr
      });
    })
    return optionsList;
  }

  render() {
    log.debug('render(): ', this.props);
    return (
      <fieldset>
        <label className="mr20">{LANGUAGES_CONTROLLER.format(this.props.languages, 'label_filterBy_category')}</label>
        <SSelect defaultValue={this.props.value}
          inputId="single-filterBy_category-select"
          name="filterBy_category"
          onS-select={this.selectionHandler.bind(this)}
          optionsList={this.getFilterByCategoryOptions() || []}
          multiple={false}
          showSelectionCount={false}
        />
      </fieldset>
    )
  }
}

function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
  };
}


// Wrap the component to inject state into it
export default connect(mapStateToProps)(ErrorsCategorySelector);